import { Injectable } from '@angular/core';
import { AppInsightsService } from 'src/lib/tcs-app-insights/app-insights-initializer.service';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { Logger, LoggerOptions, LoggerOptionsService } from './logger';

@Injectable()
export class AppInsightsLogger implements Logger {
  constructor(
    private _optionsManager: LoggerOptionsService,
    private _appInsightsService: AppInsightsService,
  ) {}

  public error(
    error: Error | string,
    properties?: { [name: string]: string },
    options?: LoggerOptions,
  ): void {
    if (this._optionsManager.canLogToAppInsights(options)) {
      const e = error instanceof Error ? error : new Error(error);
      this._appInsightsService.appInsights?.trackException({
        exception: e,
        properties,
        severityLevel: SeverityLevel.Error,
      });
    }
  }

  public warning(
    message: string,
    properties?: { [name: string]: string },
    options?: LoggerOptions,
  ): void {
    if (this._optionsManager.canLogToAppInsights(options)) {
      this._appInsightsService.appInsights?.trackTrace({
        message,
        properties,
        severityLevel: SeverityLevel.Warning,
      });
    }
  }

  public info(
    message: string,
    properties?: { [name: string]: string },
    options?: LoggerOptions,
  ): void {
    if (this._optionsManager.canLogToAppInsights(options)) {
      this._appInsightsService.appInsights?.trackTrace({
        message,
        properties,
        severityLevel: SeverityLevel.Information,
      });
    }
  }
}
